import React, { useState } from "react";
import { useQuery, gql } from "@apollo/client";

const RULES_QUERY = gql`
  query rules {
    rules {
      id
      name
      description
      conditions
    }
  }
`;

const RulesEng = () => {
  const [rulesData, setRulesData] = useState([]);

  const { data } = useQuery(RULES_QUERY);

  const handleApplyRules = () => {
    if (data?.rules) {
      for (const rule of data.rules) {
        if (rule.conditions.includes("rez_date > '2024-01-01'")) {
          console.log(rule);
        }
      }
    }
  };

  return (
    <div>
      <button onClick={handleApplyRules}>Apply Rules</button>
    </div>
  );
};

export default RulesEng;


/*







/*const GET_RULES = gql`
  query GetRules {
    rules {
      id
      name
      description
      conditions
      actions
    }
  }
`;

class RuleModel {
  constructor() {
    this.rules = [];
  }

  loadRules(rules) {
    this.rules = rules.map((rule) => {
      try {
        // ... diğer işlemler
        const actions = JSON.parse(rule.actions.replace(/'/g, '"').replace(/(\w+):/g, '"$1":').replace(/fiyat = fiyat * 1.2/g, '["fiyat = fiyat * 1.2"]')); // Eşitliği JSON dizisine çevirin
        const conditions = JSON.parse(rule.conditions.replace(/'/g, '"').replace(/(\w+):/g, '"$1":')); // Koşulları JSON dizisine çevirin
        return {
          ...rule,
          actions,
          conditions,
        };
      } catch (error) {
        console.error("Error:", error);
        return null;
      }
    }).filter(Boolean);
  }

  predict(input) {
    const results = [];

    for (const rule of this.rules) {
      if (Array.isArray(rule.conditions)) { // Dizininden emin olun
        const match = rule.conditions.every((condition) => {
          const conditionValue = condition.value;
          const inputValue = input[condition.name];

          if (typeof conditionValue === "string") {
            return conditionValue === inputValue;
          } else {
            return conditionValue === parseInt(inputValue);
          }
        });

        if (match) {
          console.log("Matched Rule:", rule);
          results.push(rule.actions.map((action) => action.value));
        }
      } else {
        console.error("rule.conditions bir dizi değil:", rule);
      }
    }

    // ... diğer işlemler
    return results;
  }
}

const RulesEng = () => {
  const [rules, setRules] = useState([]);
  const [input, setInput] = useState({
    doluluk_orani: 80,
    fiyat: 1000,
  });
  const [output, setOutput] = useState([]);
  const model = new RuleModel();

  const { loading, error, data } = useQuery(GET_RULES);

  useEffect(() => {
    if (loading) {
      console.log("Veriler yükleniyor...");
    } else if (error) {
      console.error("Hata:", error);
    } else if (data) {
      console.log("Veriler:", data);
      model.loadRules(data.rules);
      setRules(data.rules);
    }
  }, [data, loading, error]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInput((prevInput) => ({ ...prevInput, [name]: value }));
  };

  const handleButtonClick = () => {
    const prediction = model.predict(input);
    setOutput(prediction);
    console.log(prediction);
  };

  return (
    <div>
      <p>Input:</p>
      <pre>
        {JSON.stringify(input, null, 2)}
      </pre>
      <div>
        <input type="number" name="doluluk_orani" value={input.doluluk_orani} onChange={handleInputChange} />
        <input type="number" name="fiyat" value={input.fiyat} onChange={handleInputChange} />
      </div>
      <p>Output:</p>
      <pre>{JSON.stringify(output, null, 2)}</pre>
      <button onClick={handleButtonClick}>Sonuçları Konsola Yazdır</button>
    </div>
  );
};
 */

/*

import React, { useState } from "react";
import { useQuery, gql } from "@apollo/client";

const RULES_QUERY = gql`
  query rules {
    rules {
      id
      name
      description
      conditions
      actions
    }
  }
`;

const RulesEng = () => {
  const [filter, setFilter] = useState({
    field: "rez_date",
    operator: ">",
    value: "2024-01-01",
  });

  const { loading, error, data } = useQuery(RULES_QUERY);

  const handleApplyRules = () => {
    if (loading) return;
    if (error) {
      console.error("Sorguda hata oluştu:", error);
      return;
    }

    if (!data?.rules || data.rules.length === 0) {
      console.error("Kurallar bulunamadı.");
      return;
    }

    // Tüm kuralları kontrol et ve uygula
    data.rules.forEach((rule) => {
      if (matchesCondition(rule.conditions)) {
        console.log(
          `Kural ID: ${rule.id} | Koşul: ${rule.conditions} | Action: ${rule.actions}`
        );
      }
    });
  };

  const matchesCondition = (condition) => {
    try {
      const field = filter.field;
      const operator = filter.operator;
      const value = filter.value;

      // Kendi koşul kontrol mekanizmanızı oluşturun
      const conditionFunction = new Function(
        `const ${field} = ${JSON.stringify(value)}; return ${condition};`
      );

      return conditionFunction();
    } catch (error) {
      console.error("Koşul değerlendirme hatası:", error);
      return false;
    }
  };

  return (
    <div>
      <button onClick={handleApplyRules}>Apply Rules</button>
    </div>
  );
};

*/